import Account from './Account.container';

export default Account;